// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.white-background-container {
  border-radius: 5px;
  border: 1px solid #A7A9AC;
  margin-top: 20px;
  padding: 30px;
}
.white-background-container h5 {
  color: #0669B3;
}

.white-background-container-shadow {
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #818181;
  border-radius: 5px;
  border: 1px solid #A7A9AC;
  margin-top: 20px;
  padding: 30px;
}
.white-background-container-shadow h5 {
  color: #0669B3;
}

.select-job-profile-container {
  margin-top: 20px;
}

.job-profiles-missing-entitlements {
  border-radius: 5px;
  background: #FEBF31;
  font-weight: 550;
  width: 440px;
  padding: 5px 20px;
}

.setup-entitlement-column {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Entitlements.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EAEC,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;AASD;AAPC;EACC,cDoBW;ACXb;;AANA;ECUI,2CAAA;EDRH,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;AASD;AAPC;EACC,cDSW;ACAb;;AALA;EACC,gBAAA;AAQD;;AALA;EC3BI,kBD4BoB;EACvB,mBDZW;ECaX,gBAAA;EAEA,YAAA;EACA,iBAAA;AAOD;;AAJA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAOD","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.white-background-container {\n\t// @include shadow();\n\tborder-radius: 5px;\n\tborder: 1px solid $grey2;\n\tmargin-top: 20px;\n\tpadding: 30px;\n\n\th5 {\n\t\tcolor: $pearl-blue;\n\t}\n}\n.white-background-container-shadow {\n\t@include shadow();\n\tborder-radius: 5px;\n\tborder: 1px solid $grey2;\n\tmargin-top: 20px;\n\tpadding: 30px;\n\n\th5 {\n\t\tcolor: $pearl-blue;\n\t}\n}\n\n.select-job-profile-container {\n\tmargin-top: 20px;\n}\n\n.job-profiles-missing-entitlements {\n\t@include borderRadius (5px);\n\tbackground: $important;\n\tfont-weight: 550;\n\t// font-size: 18px;\n\twidth: 440px;\n\tpadding: 5px 20px;\n\n}\n.setup-entitlement-column {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
